import { __assign, __awaiter, __generator } from "tslib";
import { ContextCreator, customerActions, QueryCreator, SearchMaskGroupType, SearchMaskInputType, store, UserQueryCreator } from "ltur-state-engine";
// @ts-ignore
import UserPaginationCreator from "ltur-state-engine/dist/src/websiteStateEngine/util/UserPaginationCreator";
import Analytics from "Helper/Analytics";
import { LOGIN_FLOW_STATES, LoginFlowManager } from "Login/LoginFlowManager";
import Vue from "vue-ltur";
import { LoginRouter, ROUTE } from "Login/LoginRouter";
var BookmarkHelper = /** @class */ (function () {
    function BookmarkHelper() {
    }
    Object.defineProperty(BookmarkHelper, "additionalBookmarkInfo", {
        get: function () {
            var _a;
            var state = store.getState();
            var searchMaskGroupType = state.websiteState.app.url.context.productType;
            var searchMaskInputTypes = state.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType].inputs;
            var airports = (_a = searchMaskInputTypes[SearchMaskInputType.DEPARTURE_AIRPORT]) === null || _a === void 0 ? void 0 : _a.confirmedValue.value;
            return {
                productType: searchMaskGroupType,
                travellersAdults: searchMaskInputTypes[SearchMaskInputType.TRAVELLERS].confirmedValue.value.adults,
                travellersChildrenAge: searchMaskInputTypes[SearchMaskInputType.TRAVELLERS].confirmedValue.value.ageOfChildren,
                travelPeriodDepartureDate: searchMaskInputTypes[SearchMaskInputType.TRAVEL_PERIOD].confirmedValue.value.departureDate,
                travelPeriodReturnDate: searchMaskInputTypes[SearchMaskInputType.TRAVEL_PERIOD].confirmedValue.value.returnDate,
                travelPeriodDuration: searchMaskInputTypes[SearchMaskInputType.TRAVEL_PERIOD].confirmedValue.value.duration,
                flightDepartureAirportCodes: (airports === null || airports === void 0 ? void 0 : airports.filter(function (airport) { return !!airport.code; }).map(function (airport) { return airport.code; })) || null,
                flightDepartureAirportGroups: (airports === null || airports === void 0 ? void 0 : airports.filter(function (airport) { return !!airport.id; }).map(function (airport) { return airport.id; })) || null,
            };
        },
        enumerable: false,
        configurable: true
    });
    BookmarkHelper.addBookmarkProductToList = function (list, product, additionalInfo) {
        if (additionalInfo === void 0) { additionalInfo = this.additionalBookmarkInfo; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookmarkProduct(product, additionalInfo, list)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BookmarkHelper.removeBookmark = function (product) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, customerActions.removeBookmark(product.hotel.code)];
                    case 1:
                        _a.sent();
                        Analytics.removeBookmark(product);
                        return [2 /*return*/];
                }
            });
        });
    };
    BookmarkHelper.bookmarkProduct = function (product, additionalInfo, list) {
        if (additionalInfo === void 0) { additionalInfo = this.additionalBookmarkInfo; }
        if (list === void 0) { list = null; }
        return __awaiter(this, void 0, void 0, function () {
            var defaultBookmarkList, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = list;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, BookmarkHelper.getDefaultBookmarkList()];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        defaultBookmarkList = _a;
                        if (!(this.isProductBookmarked(product) && list === void 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.removeBookmark(product)];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, customerActions.addBookmark(product.hotel.code, defaultBookmarkList.id, __assign(__assign({}, additionalInfo), { product: product }))];
                    case 5:
                        _b.sent();
                        Analytics.addBookmark(product);
                        this.handleFlyout();
                        _b.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    BookmarkHelper.handleFlyout = function () {
        var isUser = store.getState().customerState.user.authorities.includes("ROLE_USER");
        if (isUser)
            return;
        var bookmarked = Number.parseInt(sessionStorage.getItem('bookmarked') || "0") + 1;
        sessionStorage.setItem('bookmarked', bookmarked.toString());
        if (bookmarked === 1) {
            LoginFlowManager.instance.setState(LOGIN_FLOW_STATES.INFO);
        }
        else if (bookmarked === 5) {
            LoginFlowManager.instance.setState(LOGIN_FLOW_STATES.REMINDER);
        }
    };
    BookmarkHelper.resetAnonymousBookmarks = function () {
        sessionStorage.setItem('bookmarked', "0");
    };
    BookmarkHelper.deleteBookmarks = function (giataIds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, customerActions.removeBookmarks(giataIds)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BookmarkHelper.cleanBookmarkList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, bookmarkListId, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(location.href);
                        _a = url.searchParams.get('listId');
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, BookmarkHelper.getDefaultBookmarkList()];
                    case 1:
                        _a = (_b.sent()).id;
                        _b.label = 2;
                    case 2:
                        bookmarkListId = _a;
                        return [4 /*yield*/, customerActions.cleanBookmarkList(bookmarkListId)];
                    case 3:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BookmarkHelper.removeBookmarkList = function (listId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, customerActions.removeBookmarkList(listId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BookmarkHelper.addBookmarkList = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, customerActions.addBookmarkList(name)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BookmarkHelper.saveAnonymousBookmarkList = function (list) {
        sessionStorage.setItem('anonymousBookmarkList', list);
    };
    BookmarkHelper.deleteAnonymousBookmarkList = function () {
        sessionStorage.removeItem('anonymousBookmarkList');
    };
    BookmarkHelper.getAnonymousBookmarkList = function () {
        return JSON.parse(sessionStorage.getItem('anonymousBookmarkList'));
    };
    BookmarkHelper.hasBookmarks = function () {
        return store.getState().customerState.bookmarks.length > 0;
    };
    BookmarkHelper.getBookmarkLists = function () {
        return store.getState().customerState.bookmarkLists;
    };
    BookmarkHelper.loadBookmarkedProducts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var state, context, query, pagination, references, request, url, bookmarkListId, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        state = store.getState();
                        context = ContextCreator.create(state);
                        query = __assign(__assign({ TRAVELLERS_ADULTS: 0 }, UserQueryCreator.create(state, SearchMaskGroupType.PACKAGE)), QueryCreator.createOverrides(state));
                        pagination = UserPaginationCreator.create(state);
                        if (!pagination.sorting)
                            pagination.sorting = ['price'];
                        if (query.TRAVELLERS_ADULTS === 0)
                            delete query.TRAVELLERS_ADULTS;
                        if (query.TRAVEL_PERIOD_DURATION === 10000)
                            delete query.TRAVEL_PERIOD_DURATION;
                        references = ['HOTEL_IMAGES'];
                        request = {
                            context: context,
                            query: query,
                            references: references,
                            pagination: pagination
                        };
                        url = new URL(location.href);
                        _a = url.searchParams.get('listId');
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, BookmarkHelper.getDefaultBookmarkList()];
                    case 1:
                        _a = (_b.sent()).id;
                        _b.label = 2;
                    case 2:
                        bookmarkListId = _a;
                        url.searchParams.set('listId', bookmarkListId);
                        window.history.replaceState('', '', url.toString());
                        return [4 /*yield*/, customerActions.getBookmarkedProducts(request, bookmarkListId)];
                    case 3: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    BookmarkHelper.getDefaultBookmarkList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = store.getState().customerState.bookmarkLists[0];
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, customerActions.addBookmarkList(Vue.translate('your_bookmark'))];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2: return [2 /*return*/, _a];
                }
            });
        });
    };
    BookmarkHelper.isProductBookmarked = function (product) {
        var _a;
        return ((_a = store.getState().customerState.bookmarks) === null || _a === void 0 ? void 0 : _a.indexOf(product.hotel.code)) > -1;
    };
    BookmarkHelper.isGiataIdBookmarked = function (giataId) {
        var _a;
        return ((_a = store.getState().customerState.bookmarks) === null || _a === void 0 ? void 0 : _a.indexOf(giataId)) > -1;
    };
    BookmarkHelper.getBookmarkListUrl = function (listId) {
        return LoginRouter.route(store.getState().websiteState.app.url.context.country.toLowerCase(), ROUTE.BOOKMARK_LIST, { queryParams: new URLSearchParams({ listId: listId }) });
    };
    return BookmarkHelper;
}());
export default BookmarkHelper;
